import JapaneseHolidays from 'japanese-holidays';

export class DateHelper
{
    static afterDays(days:number):Date
    {
        var d:Date = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        return d;
    }

    // 今日の日付を取得する
    public static getDateToday() : Date
    {
        return new Date();
    }

    // 日付の文字列取得
    // YYYYMMDD
    public static getString(date : Date) : string
    {
        var year = "" + date.getFullYear();
        var month = ("00" + (date.getMonth() + 1)).slice(-2);
        var day = ("00" + date.getDate()).slice(-2);

        return year + month + day;
    }

    // 今日の曜日を数値で取得する
    // 0: 日曜日 ~ 7
    public static getDayOfWeek(year, month, day)
    {
        // 今日の曜日番号を習得する
        var date = new Date(year, month - 1, day);
        return date.getDay();
    }

    // 今日が祝日か取得する
    public static isHolidayJapanese(year, month, day)
    {
        if (year == 2021)
        {
            // 2021年の祝日移動対応
            // 海の日
            if(month == 7 && day == 19) return false;
            if(month == 7 && day == 22) return true;
            // スポーツの日
            if(month == 10 && day == 11) return false;
            if(month == 7 && day == 23) return true;
            // 山の日
            if(month == 8 && day == 11) return false;
            if(month == 8 && day == 8) return true;
            if(month == 8 && day == 9) return true;
        }

        var date = new Date(year, month - 1, day);
        return JapaneseHolidays.isHoliday(date) !== undefined;
    }
    
    // 指定の日付を進める
    public static shiftDate(year, month, day, dYear, dMonth, dDay)
    {
        var date = new Date(year, month - 1, day);
        // 年
        date.setFullYear(date.getFullYear() + dYear);
        // 月
        date.setMonth(date.getMonth() + dMonth);
        // 日
        date.setDate(date.getDate() + dDay);

        return date;
    }

    // 和暦で年を取得する
    // initial : 0 : なし 1 : 平成 2 : H
    public static getJapaneseYear(year, month, day, initial = 0)
    {
        // 年、月、日を数値YYYYMMDDに変換する
        var dateNumber = year * 10000 + month * 100 + day;

        var str = "";
        if(dateNumber < 19120730)
        {
            // 明治
            if(initial == 1) { str += "明治"; }
            else if(initial == 2) { str += "M"; }
            str += year - 1867;
        }
        else if(dateNumber < 19261225)
        {
            // 大正
            if(initial == 1) { str += "大正"; }
            else if(initial == 2) { str += "T"; }
            str += year - 1911;
        }
        else if(dateNumber < 19890108)
        {
            // 昭和
            if(initial == 1) { str += "昭和"; }
            else if(initial == 2) { str += "S"; }
            str += year - 1925;
        }
        else if(dateNumber < 20190501)
        {
            // 平成
            if(initial == 1) { str += "平成"; }
            else if(initial == 2) { str += "H"; }
            str += year - 1988;
        }
        else
        {
            // 令和
            if(initial == 1) { str += "令和"; }
            else if(initial == 2) { str += "R"; }
            str += year - 2018;
        }

        return str;
    }

    // 月の英語表記を取得する
    // isShort : 省略形にする(省略表記はlabel9のものと同じ)
    public static readonly MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    public static readonly MONTH_NAMES_SHORTEN = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    public static getEnglishMonth(month, isShort)
    {
        var str = isShort ? this.MONTH_NAMES_SHORTEN[month - 1] : this.MONTH_NAMES[month - 1];
        return str;
    }

    // 各文字列表記を取得する
    // 0: なし
    // 1: 2018
    // 2: 18
    // 3: 平成30
    // 4: H30
    // 5: 30
    // 6: 2018年
    // 7: 平成30年
    public static getYearString(type, year, month, day)
    {
        var str = "";
        if(type == 1)
        {
            str = "" + year;
        }
        else if(type == 2)
        {
            str = "" + year;
            // 下二桁取り出し
            str = str.substr(str.length - 2, 2);
        }
        else if(type == 3)
        {
            str = DateHelper.getJapaneseYear(year, month, day, 1);
        }
        else if(type == 4)
        {
            str = DateHelper.getJapaneseYear(year, month, day, 2);
        }
        else if(type == 5)
        {
            str = DateHelper.getJapaneseYear(year, month, day, 0);
        }
        else if(type == 6)
        {
            str = "" + year + "年";
        }
        else if(type == 7)
        {
            str = DateHelper.getJapaneseYear(year, month, day, 1) + "年";
        }
        return str;
    }

    // 0: なし
    // 1: 8
    // 2: August
    // 3: Aug
    // 4: 8月
    public static getMonthString(type, is2Digits, month)
    {
        var str = "";
        if(type == 1)
        {
            if(is2Digits && month < 10)
            {
                str = "0" + month;
            }
            else
            {
                str = "" + month;
            }
        }
        else if(type == 2)
        {
            str = DateHelper.getEnglishMonth(month, false);
        }
        else if(type == 3)
        {
            str = DateHelper.getEnglishMonth(month, true);
        }
        else if(type == 4)
        {
            str = "" + month + "月";
        }
        return str;
    }

    // 0: なし
    // 1: 7
    public static getDayString(type, is2Digits, day)
    {
        var str = "";
        if(type == 1)
        {
            if(is2Digits && day < 10)
            {
                str = "0" + day;
            }
            else
            {
                str = "" + day;
            }
        }
        return str;
    }

    // 0: なし
    // 1: TuesDay
    // 2: Tue
    // 3: (TuesDay)
    // 4: (Tue)
    // 5: 火
    // 6: 火曜
    // 7: 火曜日
    // 8: (火)
    // 9: (火曜)
    // 10: (火曜日)
    // 11: T
    public static getWeekdayString(type, weekdayIndex)
    {
        var str = "";
        if(type == 1) { str = DateHelper.getWeekday(weekdayIndex, 1, 1, false); }
        else if(type == 2) { str = DateHelper.getWeekday(weekdayIndex, 1, 0, false); }
        else if(type == 3) { str = DateHelper.getWeekday(weekdayIndex, 1, 1, true); }
        else if(type == 4) { str = DateHelper.getWeekday(weekdayIndex, 1, 0, true); }
        else if(type == 5) { str = DateHelper.getWeekday(weekdayIndex, 0, 0, false); }
        else if(type == 6) { str = DateHelper.getWeekday(weekdayIndex, 0, 1, false); }
        else if(type == 7) { str = DateHelper.getWeekday(weekdayIndex, 0, 2, false); }
        else if(type == 8) { str = DateHelper.getWeekday(weekdayIndex, 0, 0, true); }
        else if(type == 9) { str = DateHelper.getWeekday(weekdayIndex, 0, 1, true); }
        else if(type == 10) { str = DateHelper.getWeekday(weekdayIndex, 0, 2, true); }
        else if(type == 11) { str = DateHelper.getWeekday(weekdayIndex, 1, 0, false).substr(0,1); }
        return str;
    }
    public static readonly WEEKDAY_NAMES_J = ["日", "月", "火", "水", "木", "金", "土"];
    public static readonly WEEKDAY_NAMES_E = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    public static readonly WEEKDAY_NAMES_E_SHORTEN = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    public static getWeekday(weekdayIndex, language, lengthType, isBracket : boolean)
    {
        var str = "";

        if(isBracket)
        {
            str += language == 0 ? "（" : "(";
        }

        if(language == 0)
        {
            // 日本語
            str += this.WEEKDAY_NAMES_J[weekdayIndex];
            if(lengthType == 1)
            {
                str += "曜";
            }
            else if(lengthType == 2)
            {
                str += "曜日";
            }
        }
        else if(language == 1)
        {
            // 英語
            str += lengthType == 0 ? this.WEEKDAY_NAMES_E_SHORTEN[weekdayIndex] : this.WEEKDAY_NAMES_E[weekdayIndex];
        }

        if(isBracket)
        {
            str += language == 0 ? "）" : ")";
        }

        return str;
    }
}